"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var core_1 = require("@material-ui/core");
var IconButton_1 = require("./IconButton");
var colors_1 = require("../colors");
var icons_1 = require("../icons");
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a;
    return ({
        buttonClose: {
            position: 'absolute',
            right: '16px',
            top: 0,
        },
        container: (_a = {
                backgroundColor: 'transparent',
                boxShadow: 'none',
                maxWidth: '600px',
                paddingTop: '20px',
                width: '50vw'
            },
            _a[theme.breakpoints.down('xs')] = {
                margin: '0 12px',
                width: '100vw',
            },
            _a),
        content: function (props) {
            var _a;
            return (_a = {
                    alignItems: 'center',
                    backgroundColor: (0, colors_1.getColor)('WHITE_100'),
                    background: "url(".concat(props && props.background ? props.background : (0, colors_1.getColor)('WHITE_100'), ")"),
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    borderRadius: '40px',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '48px 72px !important',
                    textAlign: 'center'
                },
                _a[theme.breakpoints.down('xs')] = {
                    padding: '48px 32px 32px !important', // !important is needed to override material ui styles
                },
                _a);
        },
    });
});
var Popup = function (_a) {
    var _b, _c;
    var children = _a.children, onClose = _a.onClose, open = _a.open, stylesProps = _a.stylesProps;
    var classes = useStyles(stylesProps);
    return (react_1.default.createElement(core_1.Dialog, { "aria-labelledby": 'popup', classes: { paper: classes.container }, onClose: onClose, open: open },
        react_1.default.createElement(core_1.DialogContent, { classes: { root: classes.content } },
            react_1.default.createElement(IconButton_1.IconButton, { className: classes.buttonClose, icon: react_1.default.createElement(icons_1.Icon.Outline.Exit, null), onClick: onClose, stylesProps: {
                    backgroundColor: ((_b = stylesProps === null || stylesProps === void 0 ? void 0 : stylesProps.closeButtonOptionalStyles) === null || _b === void 0 ? void 0 : _b.backgroundColor) || 'PURPLE_100',
                    color: ((_c = stylesProps === null || stylesProps === void 0 ? void 0 : stylesProps.closeButtonOptionalStyles) === null || _c === void 0 ? void 0 : _c.color) || 'WHITE_100',
                    size: 40,
                    withShadow: true,
                } }),
            children)));
};
exports.Popup = Popup;
